import React from "react";
import "../main.css";

function Footer() {
  const currentPage = window.location.pathname;

  const isAnzPage =
    currentPage === "/ANZUnitPrices" ||
    currentPage === "/ANZHistoricalUnitPrices";

  const disclaimerLink = isAnzPage
    ? "https://www.anz.co.nz/fundinformation"
    : "https://www.anz.co.nz/OA-legalinfo";

  return (
    <div className="footer">
      <div style={{ marginTop: 10 }}>
        <div className="bootstrap3-layout">
          <div className="container">
            <div className="panel-body">
              <div className="row">
                <div className="col-md-12">
                  <div className="row">
                    <div className="col-md-2 footer-link">
                      <a
                        href="https://www.anz.co.nz/comms/website-terms-of-use/"
                        rel="noopener noreferrer"
                        target="_blank"
                      >
                        Website Terms of Use
                      </a>
                    </div>

                    <div className="col-md-2 footer-link" style={{ paddingLeft: "7px" }}>
                      <a
                        href="https://www.anz.co.nz/about-us/media-centre/investor-information/"
                        rel="noopener noreferrer"
                        target="_blank"
                      >
                        Disclosure Statement
                      </a>
                    </div>

                    <div className="col-md-4 footer-link" style={{ paddingLeft: "0px" }}>
                      <a
                        href={disclaimerLink}
                        rel="noopener noreferrer"
                        target="_blank"
                      >
                        Legal Information and Disclaimers
                      </a>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row footerRow">
                <div className="col-md-12">
                  <p className="footer-text" >
                    © ANZ New Zealand Investments Limited, a subsidiary of ANZ Bank New Zealand Limited.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Footer;